var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSites(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.551,
    height: 20.106,
    viewBox: "0 0 14.551 20.106",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_79e13e362b47af4e46839e9fed50e897",
    "data-name": "79e13e362b47af4e46839e9fed50e897",
    transform: "translate(-161.8 -10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_554",
    "data-name": "Caminho 554",
    d: "M174.219,12.031a7.529,7.529,0,0,0-10.287,0,6.735,6.735,0,0,0-2.132,4.905,6.619,6.619,0,0,0,.587,2.733c.374.97,1.719,3.834,6.168,9.745l.521.691.521-.691c4.451-5.911,5.793-8.773,6.168-9.745a6.619,6.619,0,0,0,.587-2.733A6.735,6.735,0,0,0,174.219,12.031Zm-5.144,6.555a2.2,2.2,0,1,1,2.308-2.2A2.257,2.257,0,0,1,169.076,18.586Z",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSites);
export default __webpack_public_path__ + "static/media/Sites.59c6e1ce4429fb4fd95a2527a45a3da5.svg";
export { ForwardRef as ReactComponent };